import { FC, useRef, useState} from "react"
import { AgGridColumn, AgGridReact } from "ag-grid-react"
import '../../../../../ag-grid.css'
import '../../../../../ag-theme-alpine.css'
import { warning } from "../../../../../utils/notifications"
import { defaultRenderer, percentRenderer } from "../../../../../utils/helperFunctions"
import { EditLenhosoModalDialog } from "../EditLenhosoModalDialog/EditLenhosoModalDialog"

export const ProveedoresTableLenhoso:FC<any> = (props) => {

    const gridRef :any= useRef();

    const { data, setData, dataMASTER, saveLoading, changesFlag, setChangesFlag,fullData } = props

    const [ visible, setVisible ] = useState<boolean>(false)

    const [ selectedCell, setSelectedCell ] = useState<any>()

    const [ selectedRow, setSelectedRow ] = useState<any>()

    const [ mode, setMode] = useState<string>("")

    const [ type, setType ] = useState<string>("Ext")

    const handleClose = () => {
        setSelectedCell(undefined)
        setSelectedRow(undefined)
        setVisible(false)
        setMode("")
    }


    const handleCellStyleP = (params:any) => {
        
            return {backgroundColor: 'transparent',color: 'black',fontWeight:'normal',height:'100%',border:'1px solid #dee2e6'}
        
    }

    

    const handleCellStyle = (params:any) => {
        let original = dataMASTER?.find((ori:any) => `${ori.id_provider}${ori.id_warehouse}` === `${params.data.id_provider}${params.data.id_warehouse}`)?.[params.column.colId]
       
        if(original != params.value) {
            return {backgroundColor: 'orange', color: 'white', fontWeight:'bold',border:'1px solid #dee2e6',height:'100%'}
        } else {
            return {backgroundColor: 'transparent',color: 'black',fontWeight:'normal',border:'1px solid #dee2e6',height:'100%'}
        } 
    }

    const handleOpenCellModal = (params:any) => {

        let { colId } = params.column

        if(colId === 'comments' || colId === 'specie') {
            setSelectedCell(colId)
            setSelectedRow(params.data)
            setVisible(true)
        }   
    }
    

    return (
        <div className="ag-theme-alpine" style={saveLoading? {display:'flex',flexDirection:'column', height:'95%', width: '99%',opacity:0.6 } : {display:'flex',flexDirection:'column', height:'95%', width: '99%' }}>
            <EditLenhosoModalDialog
                visible={visible}
                setVisible={setVisible}
                handleClose={handleClose}
                
                selectedCell={selectedCell}
                setSelectedCell={setSelectedCell}
                selectedRow={selectedRow}
                setSelectedRow={setSelectedRow}
                mode={mode}
                setMode={setMode}
                dataTable={data}
                fullData={fullData}
                dataTableMASTER={dataMASTER}
                setData={setData}
                type={type}  
                setType={setType} 
                changesFlag={changesFlag}
                setChangesFlag={setChangesFlag}
    
            />
            <AgGridReact
                ref={gridRef}
                headerHeight={30}
                getRowHeight={() => 30}
                onCellDoubleClicked={handleOpenCellModal}  
                rowData={data}
                enableCellTextSelection
                >
                <AgGridColumn sort={'desc'}  resizable={true}  hide  field={"id"}></AgGridColumn>
                <AgGridColumn sortable   suppressNavigable={true} hide   headerName={"ID Proveedor"} field={"id_provider"}></AgGridColumn>
                <AgGridColumn sortable   suppressNavigable={true} hide   headerName={"ID Warehouse"} field={"id_warehouse"}></AgGridColumn>
                <AgGridColumn headerClass={"header-border header-resize"} sortable filter={true}  maxWidth={150} suppressNavigable={true} tooltipField={"name_provider"}   headerName={"Proveedor"} field={"name_provider"}></AgGridColumn>
                <AgGridColumn headerClass={"header-border header-resize"} sortable filter={true}  maxWidth={200} suppressNavigable={true} tooltipField={"name_warehouse"}   headerName={"Almacén"} field={"name_warehouse"}></AgGridColumn>      
                <AgGridColumn cellStyle={handleCellStyleP} headerClass={"header-resize"}  sortable  flex={0.5} suppressNavigable cellRenderer={defaultRenderer}   headerName="Tm" field="tm"></AgGridColumn>
                        
                <AgGridColumn cellStyle={handleCellStyleP} headerClass={"header-resize"}  sortable  flex={0.5} suppressNavigable cellRenderer={percentRenderer}    headerName="%" field="percent"></AgGridColumn>
                    
                <AgGridColumn cellStyle={handleCellStyle} headerClass={"header-resize"}  sortable   flex={0.75} suppressNavigable  headerName="Especie" field="specie"></AgGridColumn>
                    
                    
                <AgGridColumn cellStyle={handleCellStyleP} headerClass={"header-resize"}  sortable  flex={0.75} suppressNavigable   headerName="Formato" field="format"></AgGridColumn>
                     
                    
                    
                <AgGridColumn cellStyle={handleCellStyle} headerClass={"header-resize"}  sortable  flex={1.50} suppressNavigable headerName="Observaciones" field="comments"></AgGridColumn>
                

                    

            </AgGridReact>
        </div>
            
      
    )
}